var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$store.state.printing)?_c('div',[_vm._v(_vm._s(_setup.v))]):(_setup.extra?.gli)?_c('b-link',{on:{"click":function($event){return _vm.global_lookup(_setup.extra.gli, true)}}},[_vm._v(_vm._s(_setup.v))]):_c('b-link',{on:{"click":function($event){return _vm.global_lookup(_setup.v, true)}}},[_vm._v(_vm._s(_setup.v))])
}
var staticRenderFns = []

export { render, staticRenderFns }